<template>
  <div class="notifications-panel-content">
    <notifications-list
      class="notifications-panel-content__list"
      :unread-only="tab === 'unread'"
      uncleared-only
      @close="$emit('close')"
    />
  </div>
</template>

<script>
import NotificationsList from '@/components/modules/notifications/notifications-list.vue'

export default {
  name: 'NotificationsPanelContent',
  components: { NotificationsList },
  props: {
    tab: { type: String, default: 'all' }
  }
}
</script>

<style scoped lang="scss">
.notifications-panel-content {
  &__list {
    @apply h-full;
  }
}
</style>
